"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loadable = Loadable;
exports.LoadableContext = void 0;
exports.useLoadable = useLoadable;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const LoadableContext = /*#__PURE__*/(0, _react.createContext)(false);

//
// Main component
// -------------------------------------------------------------------------------------------------
exports.LoadableContext = LoadableContext;
/**
 * Sets the context for the `useLoadable` hook as well as loadable-aware components.
 */
function Loadable({
  children,
  loading = false
}) {
  return /*#__PURE__*/_react.default.createElement(LoadableContext.Provider, {
    value: loading
  }, children);
}

//
// Utility hook
// -------------------------------------------------------------------------------------------------

/**
 * Returns true of the parent `Loadable` provider has its loading state set to true.
 */
function useLoadable(override) {
  const loading = (0, _react.useContext)(LoadableContext);
  return override !== null && override !== void 0 ? override : loading;
}